import { SET_CNPJ_ACT } from './actions.type';
import { SET_CNPJ } from './mutations.type';

export default {
  [SET_CNPJ_ACT](context, data) {
    context.commit(SET_CNPJ, data);
  },
};
